import { formatCents } from "@caloteiros/shared";
import { useId } from "react";
import type { ReactElement } from "react";

/**
 * Campo de dinheiro que nunca erra: o usuario so digita numeros e eles entram
 * pela direita, como numa maquininha. Digitar 1234 vira R$ 12,34. Nao existe
 * virgula fora do lugar, nao existe texto invalido, nao existe parse.
 */
export function CurrencyInput({
  valueCents,
  onChange,
  autoFocus = false,
  label = "Valor",
}: {
  valueCents: number;
  onChange: (cents: number) => void;
  autoFocus?: boolean;
  label?: string;
}): ReactElement {
  const id = useId();

  const handleChange = (raw: string): void => {
    const digits = raw.replace(/\D/g, "").slice(0, 9);
    onChange(digits === "" ? 0 : Number.parseInt(digits, 10));
  };

  return (
    <div className="amount-box">
      <label className="label" htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        className="amount-input"
        // inputMode numeric abre o teclado de numeros no celular.
        inputMode="numeric"
        autoComplete="off"
        autoFocus={autoFocus}
        value={formatCents(valueCents)}
        onChange={(event) => handleChange(event.target.value)}
        onFocus={(event) => event.target.setSelectionRange(event.target.value.length, event.target.value.length)}
        aria-label={label}
      />
    </div>
  );
}
